/* Ofertas de brinde ("compre X, ganhe Y"): coloca e tira os brindes do carrinho.
   As ofertas vêm do app "YouShine Brinde Gel" (cadastro "Oferta de brinde" no admin), que as
   sincroniza no metacampo lido em layout/theme.liquid (#ds-brinde-regras). O preço do brinde vem
   das promoções: Yampi no checkout e o desconto do app na sacola.
   Para cada produto de brinde:
   - ganhou direito a mais brindes -> entram;
   - perdeu direito -> saem só os brindes (o que o cliente comprou à parte fica);
   - o cliente pode tirar o brinde; ele só volta se ganhar direito a mais;
   - "+" no brinde = unidade paga; "−" volta ao brinde.
   Sem atraso:
   - ao adicionar produtos (cart/add em JSON), o brinde a que o carrinho passa a ter direito vai
     no MESMO pedido, então a sacola já abre com ele. Se a Shopify recusar (ex.: brinde sem
     estoque), o pedido original é refeito sem o brinde;
   - "Finalizar compra" (yampiClick / fakeClick / getNewCheckoutURL) espera o brinde terminar
     de ajustar o carrinho antes de montar o link da Yampi.
   window.dsBrinde.pronto() devolve uma Promise que resolve quando o carrinho está acertado. */
(function () {
  var el = document.getElementById('ds-brinde-regras');
  var cfg = null;
  try { cfg = JSON.parse((el && el.textContent) || 'null'); } catch (e) {}
  var regras = (cfg && Array.isArray(cfg.regras)) ? cfg.regras : [];
  if (!regras.length) return;

  var num = function (gid) { return Number(String(gid).split('/').pop()); };
  regras = regras.map(function (r) {
    return {
      gatilho: (r.gatilho || []).map(num),
      quantidade: Math.max(1, Number(r.quantidade) || 1),
      brinde: num(r.brinde),
      quantidadeBrinde: Math.max(1, Number(r.quantidadeBrinde) || 1),
      limite: Number(r.limite) > 0 ? Number(r.limite) : Infinity
    };
  }).filter(function (r) { return r.gatilho.length && r.brinde; });
  var brindes = regras.map(function (r) { return r.brinde; }).filter(function (v, i, a) { return a.indexOf(v) === i; });
  var gatilhos = regras.reduce(function (s, r) { return s.concat(r.gatilho); }, []);

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var origFetch = window.fetch.bind(window);
  var busy = false, again = false, timer = null;
  var mudou = 0; // quantas vezes o brinde mexeu no carrinho (o checkout usa para saber se o link da Yampi ficou velho)
  var emVoo = 0;       // pedidos de carrinho ainda sem resposta
  var ultimoToque = 0; // último toque em quantidade/remover na sacola (o tema espera 300ms antes de mandar)

  function marcarToque(e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('cart-items-component')) return;
    if (t.closest('#checkout, .cart__checkout-button, .ymp_check_mainBtn')) return;
    ultimoToque = Date.now();
  }
  ['click', 'input', 'change'].forEach(function (n) { document.addEventListener(n, marcarToque, true); });

  function esperar(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function memo(token, v) {
    try {
      if (v === undefined) return JSON.parse(localStorage.getItem('ds-brinde:' + token) || 'null');
      localStorage.setItem('ds-brinde:' + token, JSON.stringify(v));
    } catch (e) { return null; }
  }
  function post(path, body) {
    return origFetch(root + path, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function getCart() {
    return origFetch(root + 'cart.js', {headers: {Accept: 'application/json'}}).then(function (r) { return r.json(); });
  }
  function sectionIds() {
    return [].map.call(document.querySelectorAll('cart-items-component'), function (c) { return c.dataset.sectionId; }).filter(Boolean);
  }
  function qtyOf(cart, variantId) {
    return cart.items.reduce(function (s, i) { return s + (i.variant_id === variantId ? i.quantity : 0); }, 0);
  }
  function avisar(itemCount, sections) {
    var ev = new Event('cart:update', {bubbles: true});
    ev.detail = {resource: undefined, sourceId: 'ds-brinde', data: {source: 'ds-brinde', itemCount: itemCount, sections: sections}};
    document.dispatchEvent(ev);
  }

  // quantas unidades de cada brinde o carrinho dá direito
  function direitos(cart, memoria) {
    var d = {};
    regras.forEach(function (r) {
      var unidades = cart.items.reduce(function (s, i) { return s + (r.gatilho.indexOf(i.variant_id) >= 0 ? i.quantity : 0); }, 0);
      if (r.gatilho.indexOf(r.brinde) >= 0) unidades -= ((memoria[r.brinde] || {}).gift || 0); // o brinde não conta para si
      var vezes = Math.min(r.limite, Math.floor(Math.max(0, unidades) / r.quantidade));
      d[r.brinde] = (d[r.brinde] || 0) + vezes * r.quantidadeBrinde;
    });
    return d;
  }

  // compara o carrinho com o que ele dá direito; atualiza `memoria` e devolve o que precisa entrar/sair
  function planejar(cart, memoria) {
    var direito = direitos(cart, memoria);
    var mudancas = [];
    brindes.forEach(function (v) {
      var st = memoria[v] || {direito: 0, gift: 0};
      var noCarrinho = qtyOf(cart, v);
      var e = direito[v] || 0;
      if (noCarrinho < st.gift) st.gift = noCarrinho;            // o cliente tirou o brinde
      var delta = 0;
      if (e > st.direito) delta = e - st.direito;                 // ganhou mais brinde
      else if (e < st.direito) delta = -Math.min(st.gift, Math.max(0, st.gift - e)); // perdeu
      st.gift += delta; st.direito = e; memoria[v] = st;
      if (delta) mudancas.push({variant: v, delta: delta});
    });
    return mudancas;
  }

  async function reconcile() {
    if (busy) { again = true; return; }
    busy = true;
    try {
      var cart = await getCart();
      if (cart.attributes._ds_brinde !== '1') cart = await post('cart/update.js', {attributes: {_ds_brinde: '1'}});
      var memoria = memo(cart.token) || {};
      var mudancas = planejar(cart, memoria);
      memo(cart.token, memoria);
      if (!mudancas.length) return;

      var ids = sectionIds(), res = null;
      for (var m = 0; m < mudancas.length; m++) {
        var ch = mudancas[m];
        if (ch.delta > 0) {
          var add = {items: [{id: ch.variant, quantity: ch.delta}]};
          if (ids.length) add.sections = ids.join(',');
          res = await post('cart/add.js', add);
        } else {
          var left = -ch.delta;
          while (left > 0) {
            var atual = await getCart();
            var linhas = atual.items.filter(function (i) { return i.variant_id === ch.variant; });
            var ultima = linhas[linhas.length - 1];
            if (!ultima) break;
            var take = Math.min(left, ultima.quantity);
            var body = {id: ultima.key, quantity: ultima.quantity - take};
            if (ids.length) body.sections = ids.join(',');
            res = await post('cart/change.js', body);
            left -= take;
          }
        }
      }
      mudou++;
      avisar(res && res.item_count, res && res.sections);
    } catch (e) {
      /* sem brinde automático desta vez; o checkout continua cobrando pelas promoções */
    } finally {
      busy = false;
      if (again) { again = false; schedule(); }
    }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(function () { timer = null; reconcile(); }, 350); }

  // espera o brinde acertar o carrinho; resolve `true` se ele mudou alguma coisa nesse meio-tempo
  async function pronto(maxMs) {
    var fim = Date.now() + (maxMs || 8000), antes = mudou;
    // primeiro, deixa o tema mandar e terminar as mudanças de quantidade que a cliente acabou de fazer
    var tema = emVoo > 0 || Date.now() - ultimoToque < 450;
    while ((emVoo > 0 || Date.now() - ultimoToque < 450) && Date.now() < fim) await esperar(60);
    do {
      if (timer) { clearTimeout(timer); timer = null; }
      if (!busy) await reconcile(); else await esperar(80);
    } while ((busy || timer || again) && Date.now() < fim);
    return tema || mudou !== antes;
  }

  // cart/add em JSON: calcula o brinde a que o carrinho passa a ter direito e manda junto
  async function adicionarComBrinde(input, init) {
    // produto que não dá direito a brinde vai direto, sem consultar o carrinho antes
    var lido = null;
    try { lido = JSON.parse(init.body); } catch (e) {}
    var ids0 = lido ? (Array.isArray(lido.items) ? lido.items.map(function (i) { return Number(i.id); }) : [Number(lido.id)]) : [];
    if (!ids0.some(function (id) { return gatilhos.indexOf(id) >= 0; })) {
      var direto = origFetch(input, init);
      direto.then(function () { schedule(); }, function () {});
      return direto;
    }
    var fim = Date.now() + 3000;
    while (busy && Date.now() < fim) await esperar(60);
    busy = true;
    var novoInit = null, plano = null;
    try {
      var body = JSON.parse(init.body);
      var lista = Array.isArray(body.items) ? body.items : (body.id ? [{id: body.id, quantity: body.quantity}] : null);
      if (lista && lista.length) {
        var cart = await getCart();
        var memoria = memo(cart.token) || {};
        var simulado = {items: cart.items.map(function (i) { return {variant_id: i.variant_id, quantity: i.quantity}; })
          .concat(lista.map(function (i) { return {variant_id: Number(i.id), quantity: Number(i.quantity) || 1}; }))};
        var mudancas = planejar(simulado, memoria);
        // só antecipa quando é pura entrada de brinde; qualquer outra situação fica com o reconcile
        if (mudancas.length && mudancas.every(function (m) { return m.delta > 0; })) {
          var extras = mudancas.map(function (m) { return {id: m.variant, quantity: m.delta}; });
          if (Array.isArray(body.items)) {
            body.items = body.items.concat(extras);
          } else {
            var item = {id: body.id, quantity: body.quantity || 1};
            if (body.properties) item.properties = body.properties;
            if (body.selling_plan) item.selling_plan = body.selling_plan;
            delete body.id; delete body.quantity; delete body.properties; delete body.selling_plan;
            body.items = [item].concat(extras);
          }
          novoInit = Object.assign({}, init, {body: JSON.stringify(body)});
          plano = memoria;
        }
      }
    } catch (e) { novoInit = null; plano = null; }

    try {
      if (!novoInit) return await origFetch(input, init);
      var resp = await origFetch(input, novoInit);
      if (!resp.ok) return await origFetch(input, init); // brinde recusado: segue só com o que o cliente pediu
      try {
        var depois = await getCart();
        memo(depois.token, plano);
        mudou++;
        var dados = await resp.clone().json();
        // depois do aviso do próprio formulário, acerta a contagem da sacola com o total real
        setTimeout(function () { avisar(depois.item_count, dados && dados.sections); }, 150);
      } catch (e) {}
      return resp;
    } finally {
      busy = false;
      schedule();
    }
  }

  // toda mudança de carrinho feita pela página, pelo tema ou por apps passa por aqui
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) return origFetch(input, init);
    emVoo++;
    var fim = function () { emVoo = Math.max(0, emVoo - 1); };
    if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof init.body === 'string' && String(init.method || '').toUpperCase() === 'POST') {
      var a = adicionarComBrinde(input, init);
      a.then(fim, fim);
      return a;
    }
    var p = origFetch(input, init);
    p.then(function () { fim(); schedule(); }, fim);
    return p;
  };

  // "Finalizar compra": espera o brinde antes de montar o link da Yampi (funções do snippets/YampiSnippet.liquid)
  function protegerCheckout(nome) {
    var orig = window[nome];
    if (typeof orig !== 'function' || orig.__dsBrinde) return;
    var envolvida = function (ev) {
      if (ev && typeof ev.preventDefault === 'function') ev.preventDefault();
      var self = this, args = arguments;
      try { if (typeof window.showYampiLoader === 'function') window.showYampiLoader(); } catch (e) {}
      pronto(8000).then(function (mexeu) {
        if (mexeu) window.yampiCheckoutUrl = '';
      }, function () {}).then(function () { orig.apply(self, args); });
    };
    envolvida.__dsBrinde = true;
    window[nome] = envolvida;
  }
  ['yampiClick', 'fakeClick', 'getNewCheckoutURL'].forEach(protegerCheckout);

  window.dsBrinde = {pronto: pronto};

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
